<script setup lang="ts">
import { computed } from 'vue';

type IconSize = 'xs' | 'sm' | 'md' | 'lg' | number | string;

const props = withDefaults(
  defineProps<{
    path: string;
    size?: IconSize;
  }>(),
  {
    size: 'md',
  },
);

const sizeValue = computed(() => {
  if (typeof props.size === 'string') {
    switch (props.size) {
      case 'xs':
        return 18;
      case 'sm':
        return 24;
      case 'md':
        return 32;
      case 'lg':
        return 64;
      default:
        return props.size;
    }
  }

  return props.size;
});
</script>

<template>
  <svg :width="sizeValue" :height="sizeValue" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path :d="path" class="fill-current" />
  </svg>
</template>
